export const mondayUppercase = "WlRup";
export default {mondayUppercase};